export default "__VITE_ASSET__15e4f95e__"